import { Injectable } from '@angular/core';
import { Capacitor, registerPlugin } from '@capacitor/core';

const ReportDownload = registerPlugin<{
  saveCsv(options: { content: string }): Promise<{ cancelled: boolean }>;
}>('ReportDownload');

@Injectable({ providedIn: 'root' })
export class ReportDownloadService {
  async save(content: string): Promise<void> {
    if (Capacitor.getPlatform() === 'android') {
      await ReportDownload.saveCsv({ content });
      return;
    }

    const url = URL.createObjectURL(new Blob([content], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'report.csv';
    document.body.appendChild(link);
    try {
      link.click();
    } finally {
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    }
  }
}
